import { enrichSubserviceForStorefront } from './storefrontServiceDisplay';

/** Placeholder copy aligned with service dashboard / custom service form fields. */
export const SERVICE_CARD_PREVIEW_PLACEHOLDERS = {
  taglineCatalog: 'e.g. Specializes in drain cleaning & clog removal',
  taglineCustom: 'e.g. Licensed & insured — free estimates',
  description: 'Describe what you offer and what customers can expect.',
  titleCustom: 'e.g. Metal roof installation',
};

/** Form placeholders keep "e.g." — preview card omits it for empty-field examples. */
export function previewExampleFromPlaceholder(text) {
  if (!text || typeof text !== 'string') return text;
  return text.replace(/^e\.g\.\s*/i, '').trim();
}

export function buildPricingFromModalConfig(modalConfig) {
  const pricing = { PriceType: modalConfig.priceType || 'NA' };
  if (modalConfig.priceType === 'Fixed') {
    pricing.Price = Number(modalConfig.fixedPrice);
  } else if (modalConfig.priceType === 'Range') {
    if (modalConfig.priceMin !== '' && modalConfig.priceMin != null) {
      pricing.Min = Number(modalConfig.priceMin);
    }
    if (modalConfig.priceMax !== '' && modalConfig.priceMax != null) {
      pricing.Max = Number(modalConfig.priceMax);
    }
  }
  return pricing;
}

/**
 * Build a storefront-shaped service row for ServiceCard preview.
 * Empty tagline/description use the same example strings as the form placeholders.
 */
export function buildStorefrontPreviewService({
  tradeId,
  subServiceType,
  modalConfig,
  isCustom = false,
  customTitle = '',
}) {
  const taglineRaw = (modalConfig?.tagline || '').trim();
  const descriptionRaw = (modalConfig?.description || '').trim();
  const titleRaw = (customTitle || '').trim();

  const sub = {
    SubServiceType: subServiceType || 'preview',
    Tagline:
      taglineRaw ||
      previewExampleFromPlaceholder(
        isCustom
          ? SERVICE_CARD_PREVIEW_PLACEHOLDERS.taglineCustom
          : SERVICE_CARD_PREVIEW_PLACEHOLDERS.taglineCatalog,
      ),
    Description:
      descriptionRaw ||
      previewExampleFromPlaceholder(SERVICE_CARD_PREVIEW_PLACEHOLDERS.description),
    Pricing: buildPricingFromModalConfig(modalConfig || {}),
  };

  if (isCustom) {
    sub.Title =
      titleRaw ||
      previewExampleFromPlaceholder(SERVICE_CARD_PREVIEW_PLACEHOLDERS.titleCustom);
    sub.IsCustom = true;
  }

  const enriched = enrichSubserviceForStorefront(sub, tradeId);

  return {
    service: enriched,
    placeholderKeys: [
      ...(!taglineRaw ? ['tagline'] : []),
      ...(!descriptionRaw ? ['description'] : []),
      ...(isCustom && !titleRaw ? ['productName'] : []),
    ],
  };
}

export function getStorefrontPreviewFieldLabels(isCustom) {
  return {
    trade: 'Trade category (set when you enroll in a trade)',
    group: 'Service group (from catalog; not editable here)',
    productName: isCustom ? 'Title' : 'Service name (from catalog)',
    tagline: 'Tagline (optional)',
    description: isCustom ? 'Description' : 'Description (optional)',
    pricing: 'Pricing (from the pricing step or section)',
  };
}
